import { BasicStore } from '@bridebook/web/app-basic/lib/types';
import createCachedSelector from 're-reselect';

const _tests = (state: BasicStore) => state.abTesting.allTests;

const getTestsVariants = (state: BasicStore) => state.abTesting.abTests;

export const getLoaderVisible = (state: BasicStore) => state.abTesting.loaderVisible;

export const getTest = createCachedSelector(
  _tests,
  (_: BasicStore, id: string) => id,
  (abtests, id) => abtests?.find((test) => test.id === id),
)((_, id) => id);

export const getTestVariant = createCachedSelector(
  getTestsVariants,
  (_: BasicStore, id: string) => id,
  (variants, id) => variants?.[id] || 'control',
)((_, id) => id);
